import { render } from "./PageNotFound404.vue?vue&type=template&id=af52dbfa&scoped=true"
import script from "./PageNotFound404.vue?vue&type=script&lang=js"
export * from "./PageNotFound404.vue?vue&type=script&lang=js"

import "./PageNotFound404.vue?vue&type=style&index=0&id=af52dbfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\feegor\\PycharmProjects\\menlor\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af52dbfa"]])

export default __exports__